import { get } from 'lodash'
import { email, emailOrPhoneRequired, required } from 'utils/validation'

export default function(values = {}, props) {
  const isAssessorDetailMandatory = get(props, 'isAssessorDetailMandatory')

  const emailOrPhoneCheck = isAssessorDetailMandatory
    && emailOrPhoneRequired(get(values, 'assessorEmail'), get(values, 'assessorPhone'))

  return {
    activityCategory: {
      id: required(get(values, 'activityCategory.id')),
      parent: {
        id: required(get(values, 'activityCategory.parent.id'))
      }
    },
    aim: required(get(values, 'aim')),
    activitySection: {
      value: required(get(values, 'activitySection'))
    },

    assessorEmail: emailOrPhoneCheck || (!isAssessorDetailMandatory && (required(get(values, 'assessorEmail')) || email(get(values, 'assessorEmail')))),
    assessorPhone: emailOrPhoneCheck,
    assessorName: (isAssessorDetailMandatory && required(get(values, 'assessorName'))) || required(get(values, 'assessorName'))
  }
}
